import Index from "../../pages/snail/yayaLand/index";
import PC from "../../pages/snail/yayaLand/pc";

const base = "yayaLand";

const routes = [{
        path: `/${base}/index*`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/pc*`,
        name: `${base}-pc`,
        component: PC
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/yayaLand.js